import { render } from "./SportKod.vue?vue&type=template&id=6251fbf2&scoped=true"
import script from "./SportKod.vue?vue&type=script&lang=js"
export * from "./SportKod.vue?vue&type=script&lang=js"

import "./SportKod.vue?vue&type=style&index=0&id=6251fbf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6251fbf2"]])

export default __exports__